import { useAuth } from "@/_core/hooks/useAuth";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";

export default function AdminGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user || user.role !== "admin") {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-4">
        <div className="w-14 h-14 rounded-2xl bg-red-500/10 flex items-center justify-center">
          <ShieldAlert className="w-7 h-7 text-red-400" />
        </div>
        <h2 className="text-lg font-bold text-white">Admin Access Required</h2>
        <p className="text-sm text-slate-400 text-center max-w-sm">
          This page is restricted to administrators. Contact the site owner if you believe you should have access.
        </p>
        <Link href="/console">
          <Button variant="outline" className="border-white/10 text-slate-300 hover:text-white">
            Back to Dashboard
          </Button>
        </Link>
      </div>
    );
  }

  return <>{children}</>;
}
